export const environment = {
  production: true,


  //apiEndpoint: 'https://uatintranet.rspl.net.in/CabBookingAPI/api/',
  //sosApiEndPoint: "https://uatintranet.rspl.net.in/AuthAPI/",
  //RedirectUrl: 'GuestHouseAndCabBooking',


  //  apiEndpoint: 'https://uat.rspl.net.in/CabBookingAPI/api/',
  //  //sosApiEndPoint: "https://uatintranet.rspl.net.in/AuthAPI/",
  //  RedirectUrl: 'GuestHouseAndCabBooking',


  // // apiEndpoint: "https://uat.rspl.net.in/CabBooking/api/",  
  // // intranetURL: 'https://uat.rspl.net.in',
  // // intranetLogin: 'https://uat.rspl.net.in/login.aspx',

  // apiEndpoint: "https://seal.rspl.net.in/api/",
  // intranetURL: 'https://uat.rspl.net.in',
  // intranetLogin: 'https://uat.rspl.net.in/login.aspx',

  apiEndpoint: "https://seal.rspl.net.in/api/",  
  intranetURL: 'https://intranet.rspl.net.in',
  intranetLogin: 'https://intranet.rspl.net.in/login.aspx',


  // apiEndpoint: "https://intranet.rspl.net.in/CabBooking/api/",  
  // intranetURL: 'https://intranet.rspl.net.in',
  // intranetLogin: 'https://intranet.rspl.net.in/login.aspx',

  //sosApiEndPoint: "https://localhost:44352/",
  //RedirectUrl: "GuestHouseAndCabBooking",

};
